import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import './index.scss';

class Dimmer extends React.Component {
  static displayName = 'Dimmer';

  static propTypes = {
    loader: PropTypes.bool,
    active: PropTypes.bool,
    inverted: PropTypes.bool,
    extraClasses: PropTypes.string,
  };

  static defaultProps = {
    loader: false,
    active: false,
    fixed: false,
    inverted: true,
    transparent: false,
    extraClasses: '',
  };

  _renderLoader = () => {
    let loader = null;
    if (this.props.loader === true) {
      loader = <div className="ui loader" />;
    }
    return loader;
  };

  render() {
    const klasses = classnames(
      'ui dimmer',
      {
        inverted: this.props.inverted,
        active: this.props.active,
        fixed: this.props.fixed,
        transparent: this.props.transparent,
      },
      this.props.extraClasses
    );

    return <div className={klasses}>{this._renderLoader()}</div>;
  }
}

export default Dimmer;
